import { ERROR_MESSAGES, ERROR_TYPES } from '../../../../lib/constants/errors';

export const getErrorMessage = (
  errorId: string,
  t: (descriptor: object, values?: object) => string
) => {
  switch (errorId) {
    case ERROR_TYPES.INVALID_CARD_STATUS:
      return t({id: ERROR_MESSAGES.INVALID_CARD_STATUS})
    default:
      return t({id: ERROR_MESSAGES.OTHER})
  }
}